"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BtBolt11InvoiceState = void 0;
var BtBolt11InvoiceState;
(function (BtBolt11InvoiceState) {
    /**
     * Expect payment
     */
    BtBolt11InvoiceState["PENDING"] = "pending";
    /**
     * Payment received but not confirmed/rejected yet. Only possible with HODL invoices.
     */
    BtBolt11InvoiceState["HOLDING"] = "holding";
    /**
     * Payment confirmed
     */
    BtBolt11InvoiceState["PAID"] = "paid";
    /**
     * Payment rejected or invoice expired.
     */
    BtBolt11InvoiceState["CANCELED"] = "canceled";
})(BtBolt11InvoiceState = exports.BtBolt11InvoiceState || (exports.BtBolt11InvoiceState = {}));
//# sourceMappingURL=BtBolt11InvoiceState.js.map